import msalInstance from "../MsEntraConfig";
import { InteractionRequiredAuthError, EventType } from "@azure/msal-browser";

export const handleMSALalAccessToken = async () => {
  //set the account
  const activeAccount = msalInstance.getActiveAccount();
  const accounts = msalInstance.getAllAccounts();
  if (!activeAccount) {
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
  }

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const authenticationResult = event.payload;
      const account = authenticationResult.account;
      msalInstance.setActiveAccount(account);
    }
  });

  //enable account storage event
  msalInstance.enableAccountStorageEvents();
  try {
    if (accounts.length > 0) {
      const activeAccount = accounts[0];
      msalInstance.setActiveAccount(activeAccount);

      const tokenResponse = await msalInstance.acquireTokenSilent({
        account: activeAccount,
        scopes: ["User.Read"], // Replace with your actual scopes
      });
      return tokenResponse.idToken;
    } else {
      console.warn("No MSAL accounts found. Cannot attach token.");
    }
  } catch (error) {
    console.error("Failed to acquire MSAL token silently:", error);
    if (error instanceof InteractionRequiredAuthError) {
      msalInstance.acquireTokenRedirect({
        scopes: ["User.Read"],
      });
    }
  }
};